import React from 'react';
import Hero from "./components/campus-syllabus/Hero";
import Main from "./components/campus-syllabus/Main";

const CampusSyllabus = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default CampusSyllabus;